import { translate } from '@/domains/core/localization/translate';
export const {
  cta,
  text2,
  text3
} = translate({
  "cta": "Create a Pro account for free",
  "text2": "Looking to save time?",
  "text3": "Create your account in 3 clicks!"
});